export const MenuMoreIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="23" cy="23" r="23" fill="white" />
      <rect x="0.5" y="0.5" width="45" height="45" rx="22.5" stroke="#916CF1" />

      <path
        d="M15.7497 25.948C16.4458 25.948 17.0101 25.3836 17.0101 24.6875C17.0101 23.9914 16.4458 23.4271 15.7497 23.4271C15.0536 23.4271 14.4893 23.9914 14.4893 24.6875C14.4893 25.3836 15.0536 25.948 15.7497 25.948Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3122 25.948C24.0083 25.948 24.5726 25.3836 24.5726 24.6875C24.5726 23.9914 24.0083 23.4271 23.3122 23.4271C22.6161 23.4271 22.0518 23.9914 22.0518 24.6875C22.0518 25.3836 22.6161 25.948 23.3122 25.948Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8747 25.948C31.5708 25.948 32.1351 25.3836 32.1351 24.6875C32.1351 23.9914 31.5708 23.4271 30.8747 23.4271C30.1786 23.4271 29.6143 23.9914 29.6143 24.6875C29.6143 25.3836 30.1786 25.948 30.8747 25.948Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
